const convertTo12HourFormat = (time) => {
  if (time === "Closed") return "Closed";

  let [hours, minutes] = time.split(":");
  hours = parseInt(hours, 10);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${hours}:${minutes} ${period}`;
};

export const convertHoursToObject = ({ hours }) => {
  const daysOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return daysOrder.map((day) => ({
    day: day,
    hours: hours[day].map((hour) =>
      hour.start === "Closed"
        ? "Closed"
        : `${convertTo12HourFormat(hour.start)} - ${convertTo12HourFormat(
            hour.end
          )}`
    ),
  }));
};
